module.exports = __webpack_public_path__ + "img/logo.925613b8.png";